module.exports = ".mat-form-field {\n  width: 124px; }\n"